module.exports = __webpack_public_path__ + "img/cover1.c9412916.png";